import { registerResource, ResourceDefinition, unregisterResource } from "ra-core";
import { useEffect } from "react";
import { useDispatch } from "react-redux";


export const useResourceRegister = (entry: ResourceDefinition) => {
  const dispatch = useDispatch();
  useEffect(() => {
      dispatch(
          registerResource(entry)
      );
      return () => { dispatch(unregisterResource(entry.name)) };
  }, [dispatch, JSON.stringify(entry)]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;

}

